var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var SuccessionPlan = function SuccessionPlan(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 6a3.001 3.001 0 0 1-2 2.83V10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V8.83a3.001 3.001 0 1 1 2 0V10a3 3 0 0 1-3 3h-2v2.17a3.001 3.001 0 1 1-2 0V13H9a3 3 0 0 1-3-3V8.83A3.001 3.001 0 1 1 10 6ZM7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm5 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm6-11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default SuccessionPlan;